import { RootState } from '@src/store/store'
import { AppStateType } from '@src/store/ducks/app/reducer'

export const selectApp = (state: RootState): AppStateType => state.app

export const selectAppIsInitialized = (state: RootState): boolean => selectApp(state).isInitialized
export const selectAppPageTitle = (state: RootState): string => selectApp(state).pageTitle
export const selectAppMessages = (state: RootState) => selectApp(state).messages
export const selectAppIsHeader = (state: RootState): boolean => selectApp(state).isHeader
export const selectAppIsEditName = (state: RootState): boolean => selectApp(state).isEditName
